<script setup lang="ts">
/**
 * FoldTab · 纵向栏目折叠手柄（UI 强制规范）
 * ------------------------------------------------------------
 * 规格：17×46 贴边竖条、«/» 符号、收起态朝内容侧半圆角，与 AppShell rail-toggle / Mail fold-tab 同款。
 * 基础样式在此（全局）；坐标由页面用 class 提供：
 *   · 全高工作台栏：bottom: 10px + left: calc(栏宽 - 17px)（贴本栏与右邻区分界线内侧）
 *   · 内容页卡片（align-items: start）：top: 10px 同理（容器底随高列走，贴顶才落在卡片上）
 *   · 收起态：left: 0、border-radius: 0 8px 8px 0；多栏同收依次并排（左移 17px 步进）
 */
defineProps<{ on: boolean; label: string }>()
const emit = defineEmits<{ (e: 'toggle'): void }>()
</script>

<template>
  <button type="button" class="fold-tab" :class="{ off: on }"
          :title="on ? '展开' + label : '收起' + label"
          :aria-label="on ? '展开' + label : '收起' + label"
          @click="emit('toggle')">{{ on ? '»' : '«' }}</button>
</template>

<style>
/* 手柄基础规格（全局类，页面只补定位 class） */
.fold-tab {
  position: absolute; bottom: 10px; z-index: 6;
  width: 17px; height: 46px; padding: 0;
  display: grid; place-items: center;
  background: var(--surface); border: 1px solid var(--line);
  border-radius: 8px; color: var(--ink-3);
  font-family: inherit; font-size: 11px; line-height: 1;
  cursor: pointer; box-shadow: 0 1px 6px #00000014;
}
.fold-tab:hover { color: var(--accent); background: var(--hover); }
</style>
